import { FormContextValues } from '@dreryk/react-common';

import { AppointmentForm } from '../../shared/form/AppointmentForm';
import { AppointmentFormBean } from '../../shared/form/AppointmentForm.types';

export type AppointmentCreateFormBean = AppointmentFormBean;

export type AppointmentCreateFormController = FormContextValues<AppointmentFormBean>;

export const AppointmentCreateForm = AppointmentForm;
